import "../App.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { ArrowRightShort } from "react-bootstrap-icons";

function OtherCourses() {
  return (
    <Container className="home-courses mb-5" fluid>
      <Row className="px-5">
        <Col>
          <div className="section-header mb-3">Other NCVC Online Courses</div>
        </Col>
      </Row>
      <Row className="course-row px-5">
        <Col xs={6} md={4} className="mb-3 mb-md-0">
          <Card className="course-card">
            <Card.Img className="course-image" variant="top" src="/tf-cbtweb2.png" alt="TF-CBTWeb2.0" />
            <Card.Body>
              <Card.Title className="course-title">TF-CBTWeb2.0</Card.Title>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-end">
              <ArrowRightShort className="course-arrow"/>
            </Card.Footer>
            <Card.Link href="https://tfcbt.musc.edu/" target="_blank" rel="noopener noreferrer" className="stretched-link"></Card.Link>
          </Card>
        </Col>
        <Col xs={6} md={4} className="mb-3 mb-md-0">
          <Card className="course-card">
            <Card.Img className="course-image" variant="top" src="/tf-cbtweb2_en_espanol.png" alt="TF-CBTWeb2.0 en Español" />
            <Card.Body>
              <Card.Title className="course-title">TF-CBTWeb2.0 (en Español)</Card.Title>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-end">
              <ArrowRightShort className="course-arrow"/>
            </Card.Footer>
            <Card.Link href="https://tfcbt-es.musc.edu/" target="_blank" rel="noopener noreferrer" className="stretched-link"></Card.Link>
          </Card>
        </Col>
        <Col xs={6} md={4}>
          <Card className="course-card">
            <Card.Img className="course-image" variant="top" src="/cpt2-hero.jpeg" alt="CPTWeb2.0" />
            <Card.Body>
              <Card.Title className="course-title">CPTWeb2.0</Card.Title>
              <Card.Text className="course-text">
                For learning Cognitive Processing Therapy for PTSD for adults and older teens.
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-end">
              <ArrowRightShort className="course-arrow"/>
            </Card.Footer>
            <Card.Link href="https://cpt2.musc.edu/" target="_blank" rel="noopener noreferrer" className="stretched-link"></Card.Link>
          </Card>
        </Col>
        {/* *** NOTE: When PEWeb2.0 is ready to be activated, uncomment this section and adjust responsive viewport sizing for ALL Cols to xs={6} md={3} */}
        {/* <Col xs={6} md={3}>
          <Card className="course-card">
            <Card.Img className="course-image" variant="top" src="/peweb2.png" alt="PEWeb2.0" />
            <Card.Body>
              <Card.Title className="course-title">PEWeb2.0</Card.Title>
              <Card.Text className="course-text">
                For learning Prolonged Exposure Therapy for PTSD in adults.
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-end">
              <ArrowRightShort className="course-arrow"/>
            </Card.Footer>
            <Card.Link href="https://pe.musc.edu/" target="_blank" rel="noopener noreferrer" className="stretched-link"></Card.Link>
          </Card>
        </Col> */}
      </Row>
    </Container>
  )
}

export default OtherCourses;
